import { WhatsAppIcon } from "./SocialIcons";

export function PhoneBadge() {
  return (
    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#34B7F1] text-white">
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4" aria-hidden="true">
        <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2z" />
      </svg>
    </span>
  );
}

export function WhatsAppBadge() {
  return (
    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#25D366] text-white">
      <WhatsAppIcon className="h-4 w-4" />
    </span>
  );
}

export function MailBadge() {
  return (
    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white">
      <svg viewBox="0 0 48 36" className="h-4 w-5" aria-hidden="true">
        <path fill="#4285F4" d="M3 36h8V16.5L0 8.25V33a3 3 0 0 0 3 3z" />
        <path fill="#34A853" d="M37 36h8a3 3 0 0 0 3-3V8.25L37 16.5z" />
        <path fill="#FBBC04" d="M37 2.25V16.5l11-8.25V3.75c0-3.7-4.23-5.82-7.2-3.6z" />
        <path fill="#EA4335" d="M11 16.5V2.25L24 12 37 2.25V16.5L24 26.25z" />
        <path fill="#C5221F" d="M0 3.75v4.5l11 8.25V2.25L7.2.15C4.23-2.07 0 .05 0 3.75z" />
      </svg>
    </span>
  );
}
